import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CreateClient from "./client/CreateClient";
import EditClient from "./client/EditClient";

/**
 * Drawer lateral para criar ou editar integradores (clientes)
 * Similar ao ProjectDrawer e EngineerDrawer
 */
export default function IntegratorDrawer({ open, onClose, mode = "create", clientId, onClientCreated }) {
  const [currentMode, setCurrentMode] = useState(mode);

  // Atualizar mode quando props mudarem
  useEffect(() => {
    setCurrentMode(mode);
  }, [mode]);

  const handleClose = () => {
    onClose();
  };

  const title = currentMode === "create" ? "Novo Integrador" : "Editar Integrador";

  return (
    <Drawer
      anchor="right"
      open={open}
      onClose={handleClose}
      sx={{
        zIndex: (theme) => theme.zIndex.drawer + 2,
      }}
      PaperProps={{
        sx: {
          width: { xs: "100%", sm: "600px", md: "800px" },
          maxWidth: "90vw",
        },
      }}
    >
      <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
        {/* Header */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            borderBottom: 1,
            borderColor: "divider",
          }}
        >
          <Box sx={{ flex: 1 }}>
            <Typography variant="h6" component="h2" sx={{ fontWeight: 600 }}>
              {title}
            </Typography>
            {currentMode === "create" && (
              <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                Preencha os dados para cadastrar um novo integrador
              </Typography>
            )}
          </Box>
          <IconButton onClick={handleClose} edge="end" sx={{ ml: 2 }}>
            <CloseIcon />
          </IconButton>
        </Box>

        <Divider />

        {/* Content */}
        <Box sx={{ flexGrow: 1, overflow: "auto", p: 2 }}>
          {currentMode === "create" ? (
            <CreateClient onClientCreated={(clientId) => {
              onClientCreated?.(clientId);
              // Não fecha imediatamente - CreateClient controla o timing
            }} />
          ) : (
            <EditClient
              initialClientId={clientId}
              onSuccess={handleClose}
            />
          )}
        </Box>
      </Box>
    </Drawer>
  );
}
